import {type ApiFetch, apiEndpoint} from "@/components/Providers/JWTProvider.tsx";

export const doGetEmployees = async (apiFetch: ApiFetch) => {
    const url = new URL("/v1/instructor/employees", apiEndpoint);
    const response = await apiFetch(url.toString());
    return await response.json();
};
